import axios from "axios";

const API_URL = "http://localhost:3000/api/test/";
const API_URL2 = "http://172.27.181.168:8080/api/v1/";
const API_URL_Domain = "http://amethyst.gistda.or.th:8080/api/v1/"
const getPublicContent = () => {
  return axios.get(API_URL + "all");
};

const getUserBoard = () => {
  return axios.get(API_URL + "user");
};

const getModeratorBoard = () => {
  return axios.get(API_URL + "mod");
};

const getAdminBoard = () => {
  return axios.get(API_URL + "admin");
};
const getshortest = (posstart,posend) =>{
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token")
  console.log(posstart)
  console.log(posend)
  return axios
  .post(
    API_URL_Domain + "operation/dijalgo",
    {
      userid: data,
      method: "ODIJ",
      posstart: posstart[0]+" "+posstart[1],
      posend: posend[0]+" "+posend[1],
      //posstart: "100.93105262 13.09982093",
      //posend: "100.92810196 13.10305386",
    },

    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
  .then((response) => {

    console.log(response)
    return response.data.path_line;
  });
}
const getshortest1 = (posstart,posend) =>{
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = JSON.parse(sessionStorage.getItem("access_token"));
  console.log(posstart)
  return axios
  .post(
    API_URL2 + "operation/dijalgo",
    {
      userid: data.userid,
      login: true,
      method: "DIJ",
      //posstart: posstart[0]+" "+posstart[1],
      //posend: posend[0]+" "+posend[1],
      posstart: "100.93105262 13.09982093",
      posend: "100.92810196 13.10305386",
    },

    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
  .then((response) => {
    return response.data;
  });
}
const UserService = {
  getPublicContent,
  getUserBoard,
  getModeratorBoard,
  getAdminBoard,
  getshortest,
  getshortest1,
}

export default UserService;
/*0: ระยะห่างระหว่าง start และ end เกิน 1 กิโลเมตร
    (Distance for test data must less than 1 km.)
1: จุด start หรือจุด end อยู่ใน polygon
    (Selected point is in restricted area)
2: พื้นที่แคบเกินไป ไม่สามารถบินเข้าไปได้ 
    (Aera is too narrow, cannot fly in this area)*/
